import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IDirection } from '../models';
import { natCerfConst } from '..';

export const getDirection = async () => {
  const { data } = await $apiV2.get<IDirection>('/nat-certificate/directions');

  return { direction: data.data };
};

export const useDirection = () => {
  const { data, ...args } = useQuery({
    queryKey: [natCerfConst.queryKeys.NATIONAL_CERTIFICATE_DIRECTION],
    queryFn: getDirection
  });

  return { ...data, ...args };
};
